
export const BLOG_TAGS = {
    GET_BLOGS: "GetBlogs",
} as const;
